import React, { useState } from 'react';
import ReportProcedureDataView from './ReportProcedureDataView';
import {
    getModifiedPhysicianFinderData,
    getModifiedDeformityCorrectionData,
    getModifiedAdditionalProcedureData,
    getModifiedPhysicianFinderDataOnCheckboxSelection,
    getModifiedBiologicsUsedDataOnCheckboxSelection,
    getModifiedRetractorUsedOnCheckboxSelection,
} from 'src/pages/reportUsage/procedure/dataTransformationUtil';
import {
    resetLevelData,
    resetMazxorCaseCoverage,
    setMazorCaseCoverageValue,
    setPhysicianTextData,
    setProcedureData,
    setRetractorUsedOtherField,
    storeItemTableData,
    validateMazorCodeRequest,
    setStealthCaseCoverageValue,
} from 'src/pages/reportUsage/redux/action/actionCreators';

import { useDispatch, useSelector } from 'react-redux';
import { getProcedureInfoRequest } from 'src/pages/reportUsage/redux/action/actionCreators';
import {
    VALIDATE_MAZOR_CODE_RESPONSE,
    SET_ADVANCE_ENERGY_DATA,
    VALIDATE_STEALTH_AXIS_CODE_RESPONSE,
} from 'src/pages/reportUsage/redux/action/types';
import {
    createProcedureDraftOrderObject,
    checkIfValidProcedureData,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { submitProcedureData } from 'src/pages/orders/redux/actions';
import {
    setReportProcedureModalState,
    setOrderSummaryModalState,
    showHideProcedureModalAction,
} from 'src/pages/orders/redux/actions';
import { getAdditionalTextareaLimit, isIOSiPhoneDevice } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { 
    REPORT_PROCEDURE_DATA,
    EQUITY,
    MANDATORY,
    VISIBLE,
} from 'src/constants/appConstants';
import { getConfigurations, setPediatricCheck } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ReportProcedureData = ({
    setProcedureInfoData,
    procedureInfoData,
    isErrorFoundInProcedure,
    isErrorFoundInFirstLevel,
    isNoUsageToReport,
    showReportProcedureModal,
    loading,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { validateMazorCodeRes, usageDetails, kitCodeValidationInProgress } = useSelector(
        (state) => state.reportUsageRootReducer
    );
    const { myCaseRef, orderSummaryModal, showBackButton } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const procedureInfoDetails = useSelector(
        (state) => state.reportUsageRootReducer.procedureInfoDetails
    );
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));
    const { procedureDataLoading } = useSelector(
        (state) => state.reportUsageRootReducer
    );
    const { procedureDataPhysicianEquity, dropdownData } = useSelector(
        (state) => ({
            procedureDataPhysicianEquity:
                state.loginReducer?.procedureDataPhysicianEquity,
            dropdownData: state.reportUsageRootReducer?.dropdownData,
        })
    );
    const [mazorxChecked, setMazorxChecked] = useState(false);
    const [mazorRoboticsCode, setMazorRoboticsCode] = useState('');
    const [mazorCaseCoverageInputValue, setMazorCaseCoverageInputValue] =
        useState('');
    const [selectedMazorCaseCoverage, setSelectedMazorCaseCoverage] =
        useState('');
    const [showBiologisDetails, setshowBiologisDetails] = useState(false);
    const [selectedPhysicianData, setSelectedPhysicianData] = useState({});
    const [physicianInputValue, setPhysicianInputValue] = useState('');
    const [procedureDropdownValue, setProcedureDropdownValue] = useState({});
    const [
        temporaryProcedureDropdownValue,
        settemporarypProcedureDropdownValue,
    ] = useState({});

    const [downArrow, setDownArrow] = useState(false);

    const [reportUsageFormObj, setReportUsageFormObj] = useState({});
    const [footerButtonStatus, setFooterButtonStatuses] = useState(false);

    const [advancedEnergyCheck, setAdvancedEnergyCheck] = useState(false);
    const [advanceEnergyProduct, setAdvanceEnergyProduct] = useState([]);
    const [advEnergyCode, setAdvEnergyCode] = useState(false);
    const [isDisabledPediatric, setDisabledPediatric] = useState(false);
    const [isPediatricSurgery, setPediatricSurgery] = useState('');
    //Stealth AXiS
    const [stealthAxisChecked, setStealthAxisChecked] = useState(false);
    const [stealthAxisCode, setStealthAxisCode] = useState('');
    const [stealthAxisAutoPilot, setStealthAxisAutoPilot] = useState(null);
    const [stealthAxisLiveAlign, setStealthAxisLiveAlign] = useState(null);
    const [
        stealthAxisCaseCoverageInputValue,
        setStealthAxisCaseCoverageInputValue,
    ] = useState('');
    const [stealthAxisCodeError, setStealthAxisCodeError] = useState('');
    const [
        selectedStealthAxisCaseCoverage,
        setSelectedStealthAxisCaseCoverage,
    ] = useState('');
    // Physician text field - backed by Redux for persistence
    const { physicianFieldText: physicianFieldTextRedux, physicianTextBoxType: physicianTextBoxTypeRedux } = useSelector(
        (state) => state.reportUsageRootReducer
    );
    const physicianFieldText = physicianFieldTextRedux || '';
    const physicianTextBoxType = physicianTextBoxTypeRedux || 'known';
    const setPhysicianFieldText = (value) => {
        dispatch(setPhysicianTextData({ physicianFieldText: value }));
    };
    const setPhysicianTextBoxType = (value) => {
        dispatch(setPhysicianTextData({ physicianTextBoxType: value }));
    };

    const proceduresList = useSelector(
        (state) =>
            state.reportUsageRootReducer.dropdownData.procedures &&
            state.reportUsageRootReducer.dropdownData.procedures.procedureList
    );
    const { statusCode, statusMessage } = useSelector(
        (state) => state.submitProcedureDataReducer
    );
    const retractorUsedOtherFieldValue = useSelector(
        (state) => state.reportUsageRootReducer.retractorUsedOtherFieldData
    );
    const {
        physicianDropdownZGReportUsageVisibility,
        physicianDropdownZGReportUsageMandatory,
        procedureTypeEquityVisibility,
        procedureTypeEquityMandatoryRule,
        pediatricSurgeryMandatory,
        pediatricSurgery,
        pediatricCheck,
        procedureVisibility,
        procedureMandatory,
        equityStealthLiveAlignVisibility,
        equityStealthAutoPilotVisibility,
        physicianTextUsageVisibility,
        physicianTextUsageMandatory,
    } = useSelector((state) => state.loginReducer);
    const uivArray = useSelector(
        (state) => state.reportUsageRootReducer.uivArray
    );
    const livArray = useSelector(
        (state) => state.reportUsageRootReducer.livArray
    );
    const reportUsageObject = useSelector(
        (state) => state.reportUsageRootReducer.reportUsageObject
    );
    const totalLevelsNumber = useSelector(
        (state) => state.reportUsageRootReducer.totalLevelsNumber
    );

    const charCountLimit = 40;
    const [textAreaCharLimit, setTextAreaCharLimit] = useState(charCountLimit);
    const showProcedureDropdown = procedureVisibility === VISIBLE;
    const procedureDataPhysicianVisibility =
        physicianDropdownZGReportUsageVisibility === VISIBLE ||
        procedureDataPhysicianEquity === VISIBLE;
    const pediatricMandatoryRule = pediatricSurgeryMandatory === MANDATORY;
    const pediatricSurgeryVisibility =
        procedureTypeEquityVisibility === VISIBLE
            ? pediatricSurgery === VISIBLE
            : false;

    useEffectWithErrorLogging(() => {
  
        resetProcedurePage();
        return () => {
            resetProcedurePage();
            dispatch(setPediatricCheck(''));
        };
    }, []);

    useEffectWithErrorLogging(() => {
        let energyProdArr = [];
        if (procedureInfoDetails && procedureInfoDetails.additionalProcedure) {
            const additionalProcedure =
                procedureInfoDetails?.additionalProcedure;
            const advancedEnergy = additionalProcedure.findIndex(
                (ind) => ind.description === 'Advanced Energy'
            );
            if (
                advancedEnergy >= 0 &&
                !additionalProcedure[advancedEnergy].isSelected
            ) {
                let advEnergyProducts = Object.keys(
                    additionalProcedure[advancedEnergy]?.advancedEnergyProduct
                ).filter((key) => {
                    return (
                        additionalProcedure[advancedEnergy]
                            ?.advancedEnergyProduct[key] === true
                    );
                });
                advEnergyProducts &&
                    advEnergyProducts.map((pr) => {
                        let obj = { description: pr, isSelected: false };
                        energyProdArr.push(obj);
                    });
                setAdvanceEnergyProduct(energyProdArr);
            }
            if (
                advancedEnergy >= 0 &&
                additionalProcedure[advancedEnergy].isSelected
            ) {
                let advEnergyProducts = Object.keys(
                    additionalProcedure[advancedEnergy].advancedEnergyProduct
                );
                advEnergyProducts &&
                    advEnergyProducts.map((pr) => {
                        let obj = {
                            description: pr,
                            isSelected:
                                additionalProcedure[advancedEnergy]
                                    .advancedEnergyProduct[pr],
                        };
                        energyProdArr.push(obj);
                    });
                setAdvanceEnergyProduct(energyProdArr);
            }
        }
    }, [procedureInfoDetails]);
    useEffectWithErrorLogging(() => {
        setPediatricSurgery(pediatricCheck);
    }, [pediatricCheck]);
    useEffectWithErrorLogging(() => {
        if (
            pediatricSurgeryVisibility &&
            dropdownData?.procedures?.defaultYesPediatricProcedures &&
            reportUsageFormObj?.procedureCode &&
            dropdownData?.procedures?.defaultYesPediatricProcedures
                ?.split(',')
                .map((p) => p.trim())
                .includes(reportUsageFormObj?.procedureCode.trim())
        ) {
            dispatch(setPediatricCheck(true));
            setDisabledPediatric(true);
        } else if (
            pediatricSurgeryVisibility &&
            dropdownData?.procedures?.defaultNoPediatricProcedures &&
            reportUsageFormObj?.procedureCode &&
            dropdownData?.procedures?.defaultNoPediatricProcedures
                ?.split(',')
                .map((p) => p.trim())
                .includes(reportUsageFormObj?.procedureCode.trim())
        ) {
            dispatch(setPediatricCheck(false));
            setDisabledPediatric(true);
        } else if (isDisabledPediatric) {
            dispatch(setPediatricCheck(''));
            setDisabledPediatric(false);
        }
    }, [
        reportUsageFormObj?.procedureCode,
        dropdownData?.procedures?.defaultYesPediatricProcedures,
        dropdownData?.procedures?.defaultNoPediatricProcedures,
    ]);
    useEffectWithErrorLogging(() => {
        if (
            procedureDropdownValue?.procedureCode !==
                reportUsageFormObj?.procedureCode &&
            !downArrow
        ) {
            resetProcedurePage();
            const data = {
                procedureCode:
                    showProcedureDropdown &&
                    procedureDropdownValue?.procedureCode
                        ? procedureDropdownValue?.procedureCode
                        : '',
                salesOrg: salesOrg,
            };
            Object.keys(procedureDropdownValue).length > 0 &&
                dispatch(getProcedureInfoRequest('Equity', data));
            setDownArrow(false);
        }
    }, [procedureDropdownValue]);

    const resetProcedurePage = () => {
        setshowBiologisDetails(false);
        dispatch(resetLevelData());
        setProcedureInfoData({});
        setAdvancedEnergyCheck(false);
        dispatch({
            type: SET_ADVANCE_ENERGY_DATA,
            payload: {},
        });
        setSelectedMazorCaseCoverage('');
        setMazorCaseCoverageInputValue('');
    };

    const radioButtonChangeHandler = (additionalProcedureData, idx, val) => {
        let modifiedData = [];
        if (
            Object.keys(additionalProcedureData).length > 0 &&
            additionalProcedureData !== 'deformityData'
        ) {
            modifiedData = [...additionalProcedureData];
            modifiedData[idx].isSelected = val;
            if (modifiedData[idx].description === 'Advanced Energy') {
                setAdvancedEnergyCheck(val);
                modifiedData[idx].advancedEnergyProduct &&
                    Object.keys(modifiedData[idx].advancedEnergyProduct).map(
                        (key) => {
                            modifiedData[idx].advancedEnergyProduct[
                                key
                            ] = false;
                        }
                    );
            }
            if (modifiedData[idx].description === 'MazorX Robot Used' && !val) {
                dispatch(setMazorCaseCoverageValue(null));
                setMazorCaseCoverageInputValue('');
                setSelectedMazorCaseCoverage('');
                const mazorIdx = modifiedData.findIndex(
                    (x) => x.description === 'MazorX Robot Used' && !val
                );
                const addProcData = [...modifiedData];
                if (mazorIdx >= 0) {
                    addProcData[mazorIdx].mazorCaseCoverage = null;
                    dispatch(
                        setProcedureData({
                            ...procedureInfoData,
                            additionalProcedure: addProcData,
                        })
                    );
                    setProcedureInfoData((prevState) => ({
                        ...prevState,
                        additionalProcedure: addProcData,
                    }));
                }
            }
            if (modifiedData[idx].description === 'Stealth AXiS' && !val) {
                dispatch(setStealthCaseCoverageValue(null));
                setStealthAxisCaseCoverageInputValue('');
                setSelectedStealthAxisCaseCoverage('');
                setStealthAxisCode('');
                setStealthAxisAutoPilot(null);
                setStealthAxisLiveAlign(null);
                setStealthAxisCodeError('');
                const stealthIdx = modifiedData.findIndex(
                    (x) => x.description === 'Stealth AXiS' && !val
                );

                const addProcData = [...modifiedData];
                if (stealthIdx >= 0) {
                    addProcData[stealthIdx].stealthCaseCoverage = null;
                    addProcData[stealthIdx].stealthAxisCode = '';
                    addProcData[stealthIdx].stealthAxisAutoPilot = null;
                    addProcData[stealthIdx].stealthAxisLiveAlign = null;
                    dispatch(
                        setProcedureData({
                            ...procedureInfoData,
                            additionalProcedure: addProcData,
                        })
                    );
                    setProcedureInfoData((prevState) => ({
                        ...prevState,
                        additionalProcedure: addProcData,
                    }));
                }
            }
            if (
                modifiedData[idx].isSelected === false &&
                modifiedData[idx].description === 'Advanced Energy'
            ) {
                advanceEnergyProduct &&
                    advanceEnergyProduct.map((item) => {
                        item.isSelected = false;
                    });
            }
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: modifiedData,
            }));
            const modifiedPhysicianFinderData = getModifiedPhysicianFinderData(
                procedureInfoData,
                val,
                modifiedData,
                idx
            );
            if (modifiedPhysicianFinderData) {
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    therapies: modifiedPhysicianFinderData,
                }));
            }
        } else if (additionalProcedureData === 'deformityData') {
            modifiedData = getModifiedDeformityCorrectionData(
                procedureInfoData,
                idx,
                val
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                technologies: modifiedData,
            }));
        }
    };
    const mazorCodeValidator = (e) => {
        const inputValue = e.target.value;
        const res = inputValue.replace(/[^A-Za-z0-9!@#$%^&*()]/g, '').slice(0, 11);
        
        setMazorRoboticsCode(res);
        const addProcData = [...procedureInfoData.additionalProcedure];
        const mazorxIdx = addProcData.findIndex(
            (x) => x.description === 'MazorX Robot Used' && x.isSelected
        );
        if (mazorxIdx >= 0) {
            addProcData[mazorxIdx].mazorKitCode = res;
            setProcedureInfoData((prevState) => ({
                ...prevState,
                additionalProcedure: addProcData,
            }));
        }
        
        const isAlphanumericOnly = /^[A-Za-z0-9]+$/.test(res);
        const isValid11Char = /^[A-Za-z0-9!@#$%^&*()]+$/.test(res);
        const isValidLength =
            (res.length === 7 && isAlphanumericOnly) || 
            (res.length === 11 && isValid11Char);

        if (isValidLength) {
            dispatch(
                validateMazorCodeRequest({ mazorKitCode: encodeURIComponent(res) })
            );
        } else {
            dispatch({
                type: VALIDATE_MAZOR_CODE_RESPONSE,
                payload: null,
            });
        }
    };
    const checkboxSelectionChangeHandler = (e, card, idx, val) => {
        let modifiedData = [];
        if (card === 'additionalProcedureData') {
            let temp = {};
            let energyProd = [...advanceEnergyProduct];
            if (energyProd[idx].description === val) {
                energyProd[idx].isSelected = !energyProd[idx].isSelected;
            }
            setAdvanceEnergyProduct(energyProd);
            let reportUsageObj = { ...reportUsageFormObj };
            temp = reportUsageObj?.procedure?.additionProcedure;
            if (temp) {
                temp.advancedEnergyProduct[val] = energyProd[idx].isSelected;
            }
            reportUsageObj.procedure.additionProcedure = temp;
            setReportUsageFormObj(reportUsageObj);
            dispatch({ type: SET_ADVANCE_ENERGY_DATA, payload: temp });
            setAdvEnergyCode(!advEnergyCode);
        } else if (card === 'physicianFinder') {
            modifiedData = getModifiedPhysicianFinderDataOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                therapies: modifiedData,
            }));
            const modifiedAdditionalProcedureData =
                getModifiedAdditionalProcedureData(
                    procedureInfoData,
                    val,
                    e.target.checked
                );
            if (modifiedAdditionalProcedureData) {
                setProcedureInfoData((prevState) => ({
                    ...prevState,
                    additionalProcedure: modifiedAdditionalProcedureData,
                }));
            }
        } else if (card === 'retractorsUsed') {
            if (
                (val === 'Other' && !e.target.checked) ||
                (val === 'None' && e.target.checked)
            ) {
                dispatch(setRetractorUsedOtherField(''));
            }
            modifiedData = getModifiedRetractorUsedOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            dispatch(
                setProcedureData({
                    ...procedureInfoData,
                    retractors: modifiedData,
                })
            );
            setProcedureInfoData((prevState) => ({
                ...prevState,
                retractors: modifiedData,
            }));
        } else if (card === 'biologicsUsed') {
            modifiedData = getModifiedBiologicsUsedDataOnCheckboxSelection(
                procedureInfoData,
                idx,
                val,
                e.target.checked
            );
            const medtronicOrCompetitve = modifiedData.filter(
                (x) => x.isSelected && x.code === '02'
            );
            const isNoneChecked =
                modifiedData.filter((x) => x.isSelected && x.code === '01')
                    ?.length > 0;
            if (medtronicOrCompetitve.length > 0) {
                setshowBiologisDetails(true);
            } else {
                setshowBiologisDetails(false);
            }
            setProcedureInfoData((prevState) => ({
                ...prevState,
                biologicsUsed: modifiedData,
                biologicsDetail:
                    isNoneChecked || medtronicOrCompetitve.length === 0
                        ? procedureInfoData.biologicsDetail?.map((item) => ({
                              ...item,
                              isMedtronicSelected: null,
                              isCompetitiveSelected: null,
                          }))
                        : prevState.biologicsDetail,
            }));
        } else if (
            card === 'biologicsDetailMedtronic' ||
            card === 'biologicsDetailCompetitive'
        ) {
            modifiedData = [...procedureInfoData.biologicsDetail];
            modifiedData[idx][
                card === 'biologicsDetailMedtronic'
                    ? 'isMedtronicSelected'
                    : 'isCompetitiveSelected'
            ] = e.target.checked;
            setProcedureInfoData((prevState) => ({
                ...prevState,
                biologicsDetail: modifiedData,
            }));
        }
    };
    const mazorCodeValidatorOnBlur = (e) => {
        const res = e.target.value.replace(/[^A-Za-z0-9!@#$%^&*()]/g, '').slice(0, 11);
        const isAlphanumericOnly = /^[A-Za-z0-9]+$/.test(res);
        
        const invalidMessage = t(
            'reportUsage.procedure.ProcedureViewContainer.additionalProcedureData.options.mazorXUsed.invalidMsg'
        );
        
        const getValidationPayload = () => {
            if (res.length === 0) {
                return null;
            }
            
            if (res.length < 7 || (res.length > 7 && res.length < 11)) {
                return {
                    statusCode: 'failed',
                    statusDescription: invalidMessage,
                };
            }
            
            if (res.length === 7) {
                return isAlphanumericOnly
                    ? validateMazorCodeRes
                    : {
                          statusCode: 'failed',
                          statusDescription: invalidMessage,
                      };
            }
            
            if (res.length === 11) {
                return validateMazorCodeRes;
            }
            
            return null;
        };
        
        dispatch({
            type: VALIDATE_MAZOR_CODE_RESPONSE,
            payload: getValidationPayload(),
        });
    };
 const stealthCodeValidatorOnBlur = (e) => {
        dispatch({
            type: VALIDATE_STEALTH_AXIS_CODE_RESPONSE,
            payload:
                e.target.value.length < 6 
                    ? {
                          statusCode: 'failed',
                          statusDescription: stealthAxisCodeError,
                      }
                    : e.target.value.length === 6
                    ? 'Valid Code'
                    : null,
        });
    };
    const closeReportProcedureDataView = () => {
        dispatch(setRetractorUsedOtherField(''));
        dispatch(setMazorCaseCoverageValue(null));
        dispatch(setStealthCaseCoverageValue(null));
        setStealthAxisCaseCoverageInputValue('');
        setSelectedStealthAxisCaseCoverage('');
        setMazorCaseCoverageInputValue('');
        setSelectedMazorCaseCoverage('');
        if (showBackButton) {
            dispatch(resetLevelData());
            dispatch(resetMazxorCaseCoverage(''));
            dispatch(
                setReportProcedureModalState({
                    showReportProcedureModal: false,
                })
            );
            dispatch(showHideProcedureModalAction(false));
        } else {
            dispatch(resetLevelData());
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: myCaseRef,
                    orderSummaryModal: !orderSummaryModal,
                })
            );
            dispatch(
                setReportProcedureModalState({
                    showReportProcedureModal: false,
                })
            );
        }
    };
    useEffectWithErrorLogging(() => {
        if (procedureInfoData && procedureInfoData.additionalProcedure) {
            const additionalProcedureData =
                procedureInfoData.additionalProcedure;
            const mazorxIdx = additionalProcedureData.findIndex(
                (x) => x.description === 'MazorX Robot Used'
            );
            if (
                mazorxIdx >= 0 &&
                additionalProcedureData[mazorxIdx] &&
                additionalProcedureData[mazorxIdx].isSelected
            ) {
                setMazorxChecked(true);
                if (additionalProcedureData[mazorxIdx].mazorKitCode) {
                    setMazorRoboticsCode(
                        additionalProcedureData[mazorxIdx].mazorKitCode
                    );
                    if (
                        validateMazorCodeRes?.statusCode !== '10723' &&
                        usageDetails.procedure?.additionProcedure
                            ?.isMazorXRoboticsUsed &&
                        usageDetails.procedure?.additionProcedure
                            ?.mazorKitCode &&
                        usageDetails.procedure?.additionProcedure
                            ?.mazorKitCode ===
                            additionalProcedureData[mazorxIdx].mazorKitCode
                    ) {
                        dispatch({
                            type: VALIDATE_MAZOR_CODE_RESPONSE,
                            payload: { statusCode: 'draft' },
                        });
                    }
                }
            } else {
                setMazorxChecked(false);
                setMazorRoboticsCode('');
                if (mazorxIdx >= 0) {
                    additionalProcedureData[mazorxIdx].mazorKitCode = '';
                }
                dispatch({
                    type: VALIDATE_MAZOR_CODE_RESPONSE,
                    payload: null,
                });
            }
        }
    }, [procedureInfoData]);
    useEffectWithErrorLogging(() => {
        if (procedureInfoData && procedureInfoData.additionalProcedure) {
            const additionalProcedureData =
                procedureInfoData.additionalProcedure;
            const stealthIdx = additionalProcedureData.findIndex(
                (x) => x.description === 'Stealth AXiS'
            );
            if (
                stealthIdx >= 0 &&
                additionalProcedureData[stealthIdx] &&
                additionalProcedureData[stealthIdx].isSelected
            ) {
                setStealthAxisChecked(true);
                if (additionalProcedureData[stealthIdx].stealthAxisCode) {
                    setStealthAxisCode(
                        additionalProcedureData[stealthIdx].stealthAxisCode
                    );
                }
                if (
                    typeof additionalProcedureData[stealthIdx]
                        .stealthAxisAutoPilot === 'boolean'
                ) {
                    setStealthAxisAutoPilot(
                        additionalProcedureData[stealthIdx]
                            .stealthAxisAutoPilot
                    );
                } else {
                    setStealthAxisAutoPilot(null);
                }
                if (
                    typeof additionalProcedureData[stealthIdx]
                        .stealthAxisLiveAlign === 'boolean'
                ) {
                    setStealthAxisLiveAlign(
                        additionalProcedureData[stealthIdx]
                            .stealthAxisLiveAlign
                    );
                } else {
                    setStealthAxisLiveAlign(null);
                }
            } else {
                setStealthAxisChecked(false);
                setStealthAxisCode('');
                setStealthAxisAutoPilot(null);
                setStealthAxisLiveAlign(null);
                if (stealthIdx >= 0) {
                    additionalProcedureData[stealthIdx].stealthAxisCode = '';
                }
                dispatch({
                    type:    VALIDATE_STEALTH_AXIS_CODE_RESPONSE,
                    payload: null,
                });
            }
        }
    }, [procedureInfoData]);
    useEffectWithErrorLogging(() => {
        if (procedureInfoData && Object.keys(procedureInfoData).length > 2) {
            const isValidProcedure = checkIfValidProcedureData(
                procedureInfoData,
                isErrorFoundInProcedure,
                isErrorFoundInFirstLevel,
                null,
                {
                    autoPilotVisible: equityStealthAutoPilotVisibility === VISIBLE,
                    liveAlignVisible: equityStealthLiveAlignVisibility === VISIBLE,
                }
            );

            const shouldCheckPhysicianEquity =
                procedureDataPhysicianVisibility &&
                physicianDropdownZGReportUsageMandatory === MANDATORY;
            const isPhysicianMissing = !selectedPhysicianData?.physicianId;
            const isPediatricSurgery =
                pediatricSurgeryVisibility && pediatricSurgeryMandatory
                    ? !(pediatricCheck !== '' && pediatricCheck !== undefined)
                    : false;
            const isProcedureDropdownInvalid =
                showProcedureDropdown &&
                procedureMandatory === MANDATORY
                    ? !procedureDropdownValue?.procedureCode ||
                      procedureDropdownValue.procedureCode.length === 0
                    : false;

            const isMazorCodeInvalid =
                mazorxChecked &&
                !(mazorRoboticsCode
                    ? validateMazorCodeRes &&
                      (validateMazorCodeRes.statusCode === '10723' ||
                          validateMazorCodeRes.statusCode === 'draft')
                    : true);

            const isPhysicianTextInvalid =
                physicianTextUsageVisibility === VISIBLE &&
                physicianTextUsageMandatory === MANDATORY &&
                physicianTextBoxType !== 'unknown' &&
                !physicianFieldText;

            const shouldDisableSubmit =
                !isValidProcedure ||
                (shouldCheckPhysicianEquity && isPhysicianMissing) ||
                isProcedureDropdownInvalid ||
                isPediatricSurgery ||
                isMazorCodeInvalid ||
                isPhysicianTextInvalid;

            setFooterButtonStatuses(shouldDisableSubmit);

            const reportUsageObj = { ...reportUsageFormObj };
            if (selectedPhysicianData && selectedPhysicianData.physicianId) {
                reportUsageObj.physicianId = selectedPhysicianData.physicianId;
            }
            if (physicianTextUsageVisibility === VISIBLE) {
                reportUsageObj.physicianFieldText =
                    physicianTextBoxType === 'unknown' ? '' : physicianFieldText || '';
            }
            reportUsageObj.myCaseRef = myCaseRef;
            if (
                procedureDropdownValue &&
                procedureDropdownValue?.procedureCode
            ) {
                reportUsageObj.procedureCode =
                    procedureDropdownValue?.procedureCode;
            }
            if (
                pediatricSurgeryVisibility &&
                pediatricCheck !== '' &&
                pediatricCheck !== undefined
            ) {
                reportUsageObj.pediatricSurgery = pediatricCheck;
            }
            if (
                Object.keys(
                    createProcedureDraftOrderObject(
                        procedureInfoData,
                        advanceEnergyProduct,
                        retractorUsedOtherFieldValue,
                        uivArray,
                        livArray,
                        totalLevelsNumber
                    )
                ).length > 0
            ) {
                reportUsageObj.procedure = createProcedureDraftOrderObject(
                    procedureInfoData,
                    advanceEnergyProduct,
                    retractorUsedOtherFieldValue,
                    uivArray,
                    livArray,
                    totalLevelsNumber
                );
            }
            setReportUsageFormObj(reportUsageObj);
        }
    }, [
        procedureInfoData,
        selectedPhysicianData,
        procedureDropdownValue,
        mazorxChecked,
        validateMazorCodeRes,
        advEnergyCode,
        retractorUsedOtherFieldValue,
        uivArray,
        livArray,
        totalLevelsNumber,
        isErrorFoundInProcedure,
        isErrorFoundInFirstLevel,
        pediatricCheck,
        physicianFieldText,
        physicianTextBoxType,
    ]);
    useEffectWithErrorLogging(() => {
        if (statusCode && statusMessage) {
            closeReportProcedureDataView();
        }
    }, [statusCode, statusMessage]);

    useEffectWithErrorLogging(() => {
        if (
            isIOSiPhoneDevice() &&
            retractorUsedOtherFieldValue.length > 0 &&
            getAdditionalTextareaLimit(retractorUsedOtherFieldValue) > 0
        ) {
            setTextAreaCharLimit(
                charCountLimit +
                    getAdditionalTextareaLimit(retractorUsedOtherFieldValue)
            );
        } else {
            setTextAreaCharLimit(charCountLimit);
        }
    }, [retractorUsedOtherFieldValue]);

    const handleSubmitProcedure = (event) => {
        if (!event.detail || event.detail == 1) {
            dispatch(submitProcedureData(reportUsageFormObj));
            // dispatch(submitProcedureData({}));

            setFooterButtonStatuses(true);

            return true;
        } else {
            return false;
        }
    };
    const setProcedureDropdownValueHandler = (value, flag = false) => {
        if (flag && value) {
            setDownArrow(true);
            value && settemporarypProcedureDropdownValue(value);
        } else {
            setDownArrow(false);

            value ? setProcedureDropdownValue(value) : setProcedureDropdownValue({procedureCode: '', procedureDescription: ''});
        }
    };
    const handleInputChange = (name, value) => {
        let object = {
            [name]: value,
        };
        if (value.length > charCountLimit) {
            const sliceLastIdx = charCountLimit - value.length;
            value = value.slice(0, sliceLastIdx);
        }
        dispatch(setRetractorUsedOtherField(value));
    };

    return (
        <ReportProcedureDataView
            advancedEnergyCheck={advancedEnergyCheck}
            advanceEnergyProduct={advanceEnergyProduct}
            showReportProcedureModal={showReportProcedureModal}
            loading={loading}
            kitCodeValidationInProgress={kitCodeValidationInProgress}
            procedureInfoData={procedureInfoData}
            radioButtonChangeHandler={radioButtonChangeHandler}
            setProcedureInfoData={setProcedureInfoData}
            mazorxChecked={mazorxChecked}
            mazorRoboticsCode={mazorRoboticsCode}
            setMazorCaseCoverageInputValue={setMazorCaseCoverageInputValue}
            mazorCaseCoverageInputValue={mazorCaseCoverageInputValue}
            setSelectedMazorCaseCoverage={setSelectedMazorCaseCoverage}
            selectedMazorCaseCoverage={selectedMazorCaseCoverage}
            mazorCodeValidator={mazorCodeValidator}
            mazorCodeValidatorOnBlur={mazorCodeValidatorOnBlur}
            validateMazorCodeRes={validateMazorCodeRes}
            checkboxSelectionChangeHandler={checkboxSelectionChangeHandler}
            handleInputChange={handleInputChange}
            retractorUsedOtherFieldValue={retractorUsedOtherFieldValue}
            textAreaCharLimit={textAreaCharLimit}
            charCountLimit={charCountLimit}
            showBiologisDetails={showBiologisDetails}
            setDropDownValue={setProcedureDropdownValueHandler}
            dropDownValue={
                downArrow
                    ? temporaryProcedureDropdownValue
                    : procedureDropdownValue
            }
            selectedPhysicianData={selectedPhysicianData}
            setSelectedPhysicianData={setSelectedPhysicianData}
            setPhysicianInputValue={setPhysicianInputValue}
            physicianInputValue={physicianInputValue}
            proceduresList={proceduresList}
            showProcedureDropdown={showProcedureDropdown}
            isNoUsageToReport={isNoUsageToReport}
            handleSubmitProcedure={handleSubmitProcedure}
            isDisabled={
                procedureDataLoading ? procedureDataLoading : footerButtonStatus
            }
            closeReportProcedureDataView={closeReportProcedureDataView}
            reportProcedureMycaseRefId={myCaseRef}
            procedureDataPhysicianVisibility={procedureDataPhysicianVisibility}
            procedureMandatoryRule={
                procedureMandatory === MANDATORY
            }
            isDisabledPediatric={isDisabledPediatric}
            setPediatricCheck={setPediatricCheck}
            isPediatricSurgery={isPediatricSurgery}
            pediatricSurgeryVisibility={pediatricSurgeryVisibility}
            pediatricMandatoryRule={pediatricMandatoryRule}
            pediatricValue={pediatricCheck}
            //Stealth AXiS

            stealthAxisChecked={stealthAxisChecked}
            stealthAxisCode={stealthAxisCode}
            setStealthAxisCode={setStealthAxisCode}
            stealthAxisAutoPilot={stealthAxisAutoPilot}
            setStealthAxisAutoPilot={setStealthAxisAutoPilot}
            stealthAxisLiveAlign={stealthAxisLiveAlign}
            setStealthAxisLiveAlign={setStealthAxisLiveAlign}
            setStealthAxisCaseCoverageInputValue={
                setStealthAxisCaseCoverageInputValue
            }
            stealthAxisCaseCoverageInputValue={
                stealthAxisCaseCoverageInputValue
            }
            setSelectedStealthAxisCaseCoverage={
                setSelectedStealthAxisCaseCoverage
            }
            selectedStealthAxisCaseCoverage={selectedStealthAxisCaseCoverage}
            stealthCodeValidatorOnBlur={stealthCodeValidatorOnBlur}
            stealthAxisCodeError={stealthAxisCodeError}
            setStealthAxisCodeError={setStealthAxisCodeError}
           
    equityStealthAutoPilotVisibility={equityStealthAutoPilotVisibility}
    equityStealthLiveAlignVisibility={equityStealthLiveAlignVisibility}
    physicianTextUsageVisibility={physicianTextUsageVisibility}
    physicianTextUsageMandatory={physicianTextUsageMandatory}
    physicianFieldText={physicianFieldText}
    setPhysicianFieldText={setPhysicianFieldText}
    physicianTextBoxType={physicianTextBoxType}
    setPhysicianTextBoxType={setPhysicianTextBoxType}
        />
    );
};
export default ReportProcedureData;
